module.exports = __webpack_public_path__ + "static/media/piano-placeholder.f764f361.jpg";